import { useState } from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { DATE_FORMAT, useDateTimeService } from 'framework/utils';
import { ClientPortalTaskActivity } from '../../types';
import { CLIENT_ACTION_MESSAGES } from './constants';

const INITIAL_VISIBLE_ACTIVITIES_COUNT = 10;

type ClientActivitySectionProps = {
  activities: ClientPortalTaskActivity[];
};

const ClientActivitySection = ({ activities }: ClientActivitySectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { formatDateWithTimezone } = useDateTimeService();
  const sortedActivities = [...activities].sort(
    (firstActivity, secondActivity) =>
      new Date(secondActivity.createdAt).getTime() - new Date(firstActivity.createdAt).getTime(),
  );
  const hasHiddenActivities = sortedActivities.length > INITIAL_VISIBLE_ACTIVITIES_COUNT;
  const visibleActivities = isExpanded ? sortedActivities : sortedActivities.slice(0, INITIAL_VISIBLE_ACTIVITIES_COUNT);

  return (
    <Stack sx={{ width: { md: '50%', sm: '100%' }, backgroundColor: 'background.paper', mb: 2 }}>
      <Typography color="primary" variant="h4" px={4} py={2.4}>
        Client activity
      </Typography>
      <Divider />
      <Stack spacing={3} sx={{ px: 4, py: 3 }}>
        {sortedActivities.length ? (
          <>
            {visibleActivities.map(activity => (
              <Box key={activity.id} sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <Typography color="textSecondary" variant="body2">
                  {formatDateWithTimezone(activity.createdAt, DATE_FORMAT.FULL)?.trim()}
                </Typography>
                <Typography>
                  {CLIENT_ACTION_MESSAGES[activity.action]} by {activity.externalUserName}
                </Typography>
              </Box>
            ))}
            {hasHiddenActivities && (
              <Box>
                <Button variant="text" onClick={() => setIsExpanded(currentValue => !currentValue)}>
                  {isExpanded ? 'Show Less' : `Show All (${activities.length})`}
                </Button>
              </Box>
            )}
          </>
        ) : (
          <Typography color="textSecondary">No activity yet</Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default ClientActivitySection;
